import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AllInboxIcon(props: IconProps) {
    return <Icon {...props} iconKey={"all_inbox"}/>
}
